<template>
  <div>
    <b-row>
      <b-col>
        <p>The following purchase orders are <strong>due</strong> to be received by the As Of date. Select PO to receive an item</p>
        <filters-component :filters="poDueFilters" :keyNdx="1" @onSearch="getData"/>
        <purchase-orders-list
          :purchaseOrdersParentList="poDueList"
          :gridId="gridId"
          isParentList
          @selectedSourceObj="onPOSelect"
          @onSort="onSort"
          class="mt-1" />
        <b-button size="sm" variant="primary" :disabled="selectedPOId == 0" @click="receiveItem">Receive Item</b-button>

        <!-- <div class="flex-column mt-4" v-if="checkClaim(CAN_RECIEVE_POS)">
          <div class="d-flex justify-content-between align-items-center">
            <p>Select a purchase order line schedule to receive the part</p>
            <b-button size="sm" variant="primary" :disabled="isDisabledReceive" @click="receiveItem">Receive Item</b-button>
          </div>
        </div> -->

        <!-- <purchase-order-line-schedules-list
          :purchaseOrderSchedulesFiltered="poScheduleDueList"
          :gridId="gridScheduleId"
          isFilteredList
          class="mt-1"
        />  -->

        <purchase-order-lines-list
          :purchaseOrderLinesFiltered="poLineDueList"
          :gridId="gridLineId"
          isFilteredList />

      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

import FiltersComponent from '../../../FilterComponent';

import moment from 'moment';
import { DATE_FORMAT, GRID_ID } from '@/shared/constants';
import PurchaseOrdersList from '@/shared/components/PurchaseOrders';
import PurchaseOrderLinesList from '@/pages/PurchaseOrders/components/PurchaseOrderLines';
import PurchaseOrderLineSchedulesList from '@/shared/components/PurchaseOrderLineSchedules';
import { filter } from 'minimatch';

export default {
  components: {
    FiltersComponent,
    PurchaseOrdersList,
    PurchaseOrderLinesList,
    PurchaseOrderLineSchedulesList
  },
  data() {
    return {
      DATE_FORMAT,
      poDueFilters: {
        asOfDate: moment().format(DATE_FORMAT)
      },
      selectedPOId: 0,
      poScheduleSelected: {},
      lineListName: 'poLineDueList',
      scheduleListName: 'poScheduleDueList',
      gridId: GRID_ID.PURCHASE_ORDERS_RECEIVING_DUE,
      gridLineId: GRID_ID.PURCHASE_ORDERS_LINES_RECEIVING_DUE
    };
  },
  computed: {
    ...mapGetters('shippingReceiving', [
      'poDueList',
      'poLineDueList',
      'poScheduleDueList',
      'poPageInfo'
    ]),
    isDisabledReceive() {
      return Object.keys(this.poScheduleSelected).length == 0;
    }
  },
  methods: {
    ...mapActions('shippingReceiving', [
      'getPoLinesSchedules',
      'getPoLinesBySelectedPo',
      'getPoScheduleBySelectedPo',
      'setSortInfo'
    ]),
    ...mapMutations('shippingReceiving', ['setItem']),
    // ...mapMutations('purchaseorderlineschedules', [ 'setPurchaseOrderLineSchedulesList' ]),
    async getData() {
      /*this.setList({key: 'poScheduleDueList', value: []});*/
      
      await this.getPoLinesSchedules({
        filters: {
          ...this.poDueFilters,
          isDue: true,
          isPastDue: false,
          isNotScheduled: false
        }
      })
    },
    async onPOSelect($event) {
      this.selectedPOId = $event.id;
      this.poScheduleSelected = {};
      await this.getPoLinesBySelectedPo({
        purchaseOrderId: $event.id,
        isState: this.lineListName
      });
    },
    receiveItem() {
      this.$emit('onReceiveItem', { purchaseOrderId: this.selectedPOId });
    },
    onSort(evt) {
      this.setSortInfo({ ...evt, pageInfoState: 'poPageInfo' });
    }
  },
  watch: {
    poPageInfo() {
      this.getData();
    }
  },
  mounted() {
    this.setItem({ resource: this.lineListName, payload: [] });
    this.getData();
  }
};
</script>

<style scoped>
.sched-division {
    padding: 0.5rem;
    margin-top: 2rem;
}
</style>
